export const AmbientBackground = ({ scanline = false }: { scanline?: boolean }) => {
  const position = scanline ? 'fixed' : 'absolute';
  return (
    <>
      <div
        aria-hidden="true"
        className={`${position} inset-0 z-0 pointer-events-none bg-[radial-gradient(circle,rgba(70,192,186,0.1)_1px,transparent_1px)] bg-[length:30px_30px]`}
      />
      {scanline && (
        <div
          aria-hidden="true"
          className="fixed left-1/2 top-0 z-0 h-[260px] w-[70vw] -translate-x-1/2 animate-aurora-sweep rounded-full pointer-events-none blur-[48px]"
          style={{
            background:
              'radial-gradient(ellipse at center, rgba(70,192,186,0.18) 0%, rgba(67,101,173,0.10) 45%, transparent 75%)',
          }}
        />
      )}
      <div
        aria-hidden="true"
        className={`${position} -top-[100px] -left-[80px] z-0 h-[500px] w-[500px] animate-glow-pulse rounded-full pointer-events-none blur-[120px]`}
        style={{ background: 'radial-gradient(circle, rgba(70,192,186,0.16) 0%, transparent 70%)' }}
      />
      <div
        aria-hidden="true"
        className={`${position} -bottom-[80px] -right-[60px] z-0 h-[450px] w-[450px] animate-glow-pulse-slow rounded-full pointer-events-none blur-[120px]`}
        style={{ background: 'radial-gradient(circle, rgba(67,101,173,0.16) 0%, transparent 70%)' }}
      />
    </>
  );
};
